import React from "react";

export default function PageHeader({ eyebrow, title, description, actions, testId }) {
  return (
    <div
      className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 border-b border-neutral-900 px-6 lg:px-10 py-8"
      data-testid={testId || "page-header"}
    >
      <div>
        {eyebrow && (
          <div className="text-[10px] uppercase tracking-[0.3em] text-neutral-500 mb-3">
            {eyebrow}
          </div>
        )}
        <h1 className="font-heading text-3xl md:text-4xl font-semibold tracking-tight text-white">
          {title}
        </h1>
        {description && (
          <p className="mt-2 text-sm text-neutral-400 max-w-2xl">{description}</p>
        )}
      </div>
      {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
    </div>
  );
}
